import { useGetTerminals } from "../../../hooks/api/queries/useTerminals";
import { useUrlSearch } from "../../../hooks/useUrlSearch";
import { useSelector } from "react-redux";
import { getUrlQuerysection } from "../../../helpers";
import { useEffect } from "react";

export const useSMStoreTerminal = ({ isEnabled = true, queries = null }) => {
  const { search, filterByKey } = useUrlSearch();
  queries = queries || getUrlQuerysection();
  const { businessDetails } = useSelector(
    (state) => state.profileDetailsReducer,
  );

  const { data, isLoading } = useGetTerminals({
    queries,
    isEnabled: isEnabled,
  });

  useEffect(() => {
    if (
      !search.get("terminal_type") &&
      businessDetails?.integrated_payment_providers?.length > 0
    )
      filterByKey(
        "terminal_type",
        businessDetails?.integrated_payment_providers?.[0],
      );
  }, []);

  return {
    search,
    isLoading,
    terminals: data?.data || [],
    integratedPaymentProviders: businessDetails?.integrated_payment_providers,
    filterByKey,
  };
};
